<template>
  <div class="mt-3">

    <div class="row">
      <div class="col-md-8 col-sm-12 offset-md-2">

        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
						<span class="m-portlet__head-icon m--hide">
						<i class="la la-gear"></i>
						</span>
                <h3 class="m-portlet__head-text">
                  Account
                </h3>
              </div>
            </div>
          </div>
          <!--begin::Form-->
          <form class="m-form m-form--state">
            <div class="m-portlet__body">

              <photo-upload class="mb-4" ref="photoUpload" :initialPhoto="user.photo" @photoUpdated="photoUpdated"></photo-upload>

              <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'name' }">
                <label for="name">Name</label>
                <input type="text" id="name" v-model="user.name" placeholder="Name" class="form-control m-input">
              </div>

              <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'tagline' }">
                <label for="tagline">Tagline</label>
                <input type="text" id="tagline" v-model="user.tagline" placeholder="Tagline" class="form-control m-input">
              </div>

              <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'old_password' }">
                <label for="old_password">Old password</label>
                <input type="password" id="old_password" v-model="user.old_password" placeholder="Old password" class="form-control m-input">
              </div>

              <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'password' }">
                <label for="password">New password</label>
                <input type="password" id="password" v-model="user.password" placeholder="New password" class="form-control m-input">
              </div>

              <div class="form-group" v-bValidate="{ 'errors' : errors, 'name' : 'password_confirmation' }">
                <label for="password_confirmation">Repeat password</label>
                <input type="password" id="password_confirmation" v-model="user.password_confirmation" placeholder="Repeat password" class="form-control m-input">
              </div>

            </div>
            <div class="m-portlet__foot m-portlet__foot--fit">
              <div class="m-form__actions m-form__actions">
                <a class="btn btn-primary text-white" @click="submit()">Save</a>
              </div>
            </div>
          </form>
          <!--end::Form-->
        </div>


      </div>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import PhotoUpload from './../users/PhotoUplaod'

  export default {
    components: {
      'photo-upload': PhotoUpload,
    },
    created() {
      this.axios.get('/me').then(response => {
        this.loadUser(response.data.data)
      }).catch(error => {});
    },
    data() {
      return {
        user: {
          name: null,
          tagline: null,
          photo: null,
        },
        errors: false,
      }
    },
    methods: {
      loadUser(user) {
        this.user.name = user.name;
        this.user.tagline = user.tagline;
        this.user.photo = user.photo;
      },
      submit() {
        this.axios.post('/users/updateMe', this.user).then(response => {

          if (response.status === 202) {
            this.$refs.photoUpload.submit(response.data.data.id)

            if (this.user.password) {
              delete this.user.password;
              delete this.user.old_password;
              delete this.user.password_confirmation;
            }
            this.$forceUpdate()

            this.loadUser(response.data.data)

            this.errors = false
            this.$root.$emit('update-success')
          }
        }).catch(err => {
          if (err.response.data && err.response.data.errors) {
            this.errors = err.response.data.errors;
          }
        })
      },
      photoUpdated(data) {
        this.user.photo = data.src;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/account/Index.vue